const ASSET_DOMAIN = 'assets.hoslog.jp';

export function transformImageUrl(value: unknown): unknown {
  if (typeof value === 'string') {
    const index = value.indexOf(ASSET_DOMAIN);

    if (index !== -1) {
      return value.slice(index + ASSET_DOMAIN.length);
    }

    return value;
  }

  if (Array.isArray(value)) {
    return value.map(transformImageUrl);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, value]) => [key, transformImageUrl(value)]));
  }

  return value;
}
